import { render } from "./FeedBack.vue?vue&type=template&id=a89c3a4e&scoped=true"
import script from "./FeedBack.vue?vue&type=script&lang=js"
export * from "./FeedBack.vue?vue&type=script&lang=js"

import "./FeedBack.vue?vue&type=style&index=0&id=a89c3a4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a89c3a4e"]])

export default __exports__